import React from "react"
import Autocomplete from "./Autocomplete"
import { humanize } from "utils"
import * as API from 'api'
import PropTypes from "prop-types"
import pluralize from 'pluralize'
import {camelized, capitalize} from 'utils'
import {useAccessToken} from "hooks";

export const AutocompleteSearch = (props) => {
  const {
    name,
    subject = name,
    searchableField = "name",
    filterName = "search",
    ...rest
  } = props
  const acquireAccessToken = useAccessToken()

  const defaultOnSuggestionsFetchRequested = async (text, callback) => {
    const type = pluralize(camelized(subject, {lower: true}))
    const klass = capitalize(type)
    const accessToken = await acquireAccessToken()
    const { data } = await API[klass].index(accessToken, {
      options: {
        fields: {[type]: `${searchableField}`},
        filter: {[filterName]: text},
        page: { number: 1, size: 1000 },
        sort: 'title'
      }
    })
    callback(data)
  }

  const defaultGetOptionLabel = option => {
    if (option && option[searchableField]) {
      return option[searchableField]
    }

    return ""
  }

  const getOptionLabel = props.getOptionLabel || defaultGetOptionLabel
  const onSuggestionsFetchRequested = props.onSuggestionsFetchRequested || defaultOnSuggestionsFetchRequested

  return (
      <Autocomplete
          key={name}
          fullWidth
          name={name}
          label={props.label || humanize(name)}
          getOptionLabel={getOptionLabel}
          onSuggestionsFetchRequested={onSuggestionsFetchRequested}
          {...rest}
      />
  )
}

AutocompleteSearch.propTypes = {
  name: PropTypes.string.isRequired,
  subject: PropTypes.string,
  getOptionLabel: PropTypes.func,
  onSuggestionsFetchRequested: PropTypes.func,
  searchableField: PropTypes.string,
  filterName: PropTypes.string,
}

export default AutocompleteSearch